import { render } from "./KoruTextOverlay.vue?vue&type=template&id=46df14c4&ts=true"
import script from "./KoruTextOverlay.vue?vue&type=script&lang=ts"
export * from "./KoruTextOverlay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__